/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini200,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini400,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini401,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini500,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniPathParams,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniQueryParams,
} from "../../types/individualPaymentVanzoliniController/PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini.ts";

export const postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniPathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniPathParams>;

export const postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniQueryParamsSchema =
  z
    .object({
      invoiceEmail: z.optional(z.string()),
      invoiceBody: z.optional(z.string()),
    })
    .optional() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini200>;

/**
 * @description Regra de negócio violada
 */
export const postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini400Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini500>;

export const postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniMutationResponseSchema =
  z.lazy(
    () =>
      postApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzolini200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidInvoiceFuturePaymentVanzoliniMutationResponse>;
